export interface CfdReferenceQuote {
  price: number;
  timestamp: string;
}

// USD snapshots read from stream.valore.markets on 2026-10-22.
// These are display-only references, never executable quotes. Retain the
// provider time: loading the app must not make a saved price current.
const REFERENCE_QUOTES: Readonly<Record<string, Readonly<CfdReferenceQuote>>> = {
  'IWDA.L': { price: 146.08, timestamp: '2026-10-22T10:48:44.000Z' },
  'EWLD.PA': { price: 47.01328, timestamp: '2026-10-22T10:38:03.000Z' },
  'WSRIA.SW': { price: 28.729473, timestamp: '2026-10-22T07:03:05.000Z' },
  'CSPX.L': { price: 829.69, timestamp: '2026-10-22T10:48:44.000Z' },
  'NOVO-B.CO': { price: 39.435, timestamp: '2026-10-22T11:03:37.000Z' },
};

const isValidReference = (quote: CfdReferenceQuote | null | undefined, now: number): quote is CfdReferenceQuote => {
  if (!quote || !Number.isFinite(quote.price) || quote.price <= 0) return false;
  const time = Date.parse(quote.timestamp);
  return Number.isFinite(time) && time <= now;
};

export function getListedCfdReferenceQuote(
  symbol: string,
  receivedQuote: CfdReferenceQuote | null | undefined,
  now = Date.now(),
): CfdReferenceQuote | null {
  if (!Object.prototype.hasOwnProperty.call(REFERENCE_QUOTES, symbol)) return null;
  const saved = REFERENCE_QUOTES[symbol];
  const savedIsValid = isValidReference(saved, now);
  // Prefer a newer received price, even if it is too old to open a position.
  if (isValidReference(receivedQuote, now)
    && (!savedIsValid || Date.parse(receivedQuote.timestamp) >= Date.parse(saved.timestamp))) {
    return { price: receivedQuote.price, timestamp: receivedQuote.timestamp };
  }
  return savedIsValid ? { ...saved } : null;
}
